import Translator from '%app/js/common/services/translator';

export const STEP_ID_TICKETS = 'tickets';
export const STEP_ID_DETAILS = 'details';
export const STEP_ID_PAYMENT = 'payment';
export const STEP_ID_CONFIRMATION = 'confirmation';

const STEP_ORDER = [
    STEP_ID_TICKETS,
    STEP_ID_DETAILS,
    STEP_ID_PAYMENT,
    STEP_ID_CONFIRMATION,
];

const STEP_ID_BY_BACKEND_NAME = new Map([
    ['entry_point', STEP_ID_TICKETS],
    ['ticket_selection_combined', STEP_ID_TICKETS],
    ['user_details_fill', STEP_ID_DETAILS],
    ['payment_type_selection', STEP_ID_PAYMENT],
    ['finalize_payment', STEP_ID_PAYMENT],
    ['payment_redirect', STEP_ID_PAYMENT],
    ['exit_point', STEP_ID_CONFIRMATION],
]);

export function getStepIdAtIndex(stepIndex) {
    return STEP_ORDER[stepIndex] ?? null;
}

export function getStepIndexFromId(stepId) {
    const index = STEP_ORDER.indexOf(stepId);
    return index >= 0 ? index : null;
}

export function getStepIndexFromBackendName(backendName) {
    return getStepIndexFromId(STEP_ID_BY_BACKEND_NAME.get(backendName));
}

function buildStepLabels(stepIds) {
    return stepIds.map(stepId => (
        Translator.trans(`evp_ticket_frontend.redesign.checkout.stepper.${stepId}`)
    ));
}

export default function buildDefaultSteps() {
    return buildStepLabels(STEP_ORDER);
}
